<h2 mat-dialog-title>{{ 'EMAIL_BUILDER.BUSINESS_CONTACT_SELECTOR.PREVIEW_AS' | translate }}</h2>
<mat-divider></mat-divider>
<mat-button-toggle-group [(ngModel)]="type">
  <mat-button-toggle value="Contact">
    <mat-icon>person</mat-icon>
    {{ 'EMAIL_BUILDER.BUSINESS_CONTACT_SELECTOR.CONTACT' | translate }}
  </mat-button-toggle>
  <mat-button-toggle value="Business">
    <mat-icon>business</mat-icon>
    {{ 'EMAIL_BUILDER.BUSINESS_CONTACT_SELECTOR.ACCOUNT' | translate }}
  </mat-button-toggle>
</mat-button-toggle-group>

<div class="search-container">
  <glxy-form-field suffixIcon="search">
    <input
      matInput
      type="text"
      placeholder="{{ 'EMAIL_BUILDER.BUSINESS_CONTACT_SELECTOR.SEARCH' | translate }}"
      [formControl]="type === 'Contact' ? contactSearchFormField : businessSearchFormField"
    />
  </glxy-form-field>
</div>

@if (type === 'Contact') {
  <mat-dialog-content class="options-container">
    @if (contactLoadingFirstPage() === false && contacts()) {
      @if (contacts().length > 0) {
        @for (contact of contacts(); track contact) {
          <div class="option" (click)="selectContact(contact)">
            <div class="option-title">
              {{ contact.name }}
            </div>
            <div class="option-subtitle">
              {{ contact.email }}
            </div>
          </div>
        }
      } @else {
        <ng-container *ngTemplateOutlet="emptyState"></ng-container>
      }
      <div class="load-more-container">
        @if (!contactLoading() && contactHasMore()) {
          <div
            class="load-more-check"
            inViewport
            [inViewportOptions]="{ partial: false }"
            (inViewportAction)="loadMoreContacts($event)"
          ></div>
        }
        @if (contactLoading()) {
          <glxy-loading-spinner></glxy-loading-spinner>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    }
  </mat-dialog-content>
} @else {
  <mat-dialog-content class="options-container">
    @if (businessLoadingFirstPage() === false && businesses()) {
      @if (businesses().length > 0) {
        @for (account of businesses(); track account) {
          <div class="option" (click)="selectBusiness(account)">
            <div class="option-title">
              {{ account.napData?.companyName }}
            </div>
            <div class="option-subtitle">
              {{ account.napData | formatAddressToString }}
            </div>
            @if (account.constraints?.length > 0) {
              <p matListItemMeta>PID: {{ getPartnerIdFromConstraints(account.constraints) }}</p>
            }
          </div>
        }
      } @else {
        <ng-container *ngTemplateOutlet="emptyState"></ng-container>
      }
      <div class="load-more-container">
        @if (!businessLoading() && businessHasMore()) {
          <div
            class="load-more-check"
            inViewport
            [inViewportOptions]="{ partial: false }"
            (inViewportAction)="loadMoreAccounts($event)"
          ></div>
        }
        @if (businessLoading()) {
          <glxy-loading-spinner></glxy-loading-spinner>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    }
  </mat-dialog-content>
}

<ng-template #emptyState>
  <div class="empty">
    @if (type === 'Contact') {
      {{ 'EMAIL_BUILDER.BUSINESS_CONTACT_SELECTOR.NO_CONTACTS_FOUND' | translate }}
    } @else {
      {{ 'EMAIL_BUILDER.BUSINESS_CONTACT_SELECTOR.NO_ACCOUNTS_FOUND' | translate }}
      @if (!data.hideCreateBusiness) {
        <div class="cta-button">
          <button mat-raised-button color="primary" (click)="createBusiness()">
            {{ 'EMAIL_BUILDER.BUSINESS_CONTACT_SELECTOR.CREATE_ACCOUNT' | translate }}
          </button>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #loading>
  <div>
    @for (i of Array(8); track i) {
      <div class="stencil-shimmer loading-shimmer"></div>
    }
  </div>
</ng-template>
